<template>
    <rd-card type="vertical" margins="none">
        <rd-card-header>
            <rd-header :title="$t('dashboard.valuesByOrderType.title')" margins="none" size="medium" />
        </rd-card-header>
        <rd-card-content>
            <!--:tooltip="{ enabled: true, format: { type: 'fixedPoint', precision: 2 }, location: 'edge' }"-->
            <dx-chart :data-source="getValuesByDepartmentAndTypeChartDataSource"
                      :common-series-settings="commonSeriesSettings"
                      :legend="legendSettings"
                      :loadingIndicator="{ enabled: true }"
                      :size="{ width: '100%' }"
                      :series="getValuesByDepartmentAndTypeChartSeries"
                      :argument-axis="argumentSettings">
                <dx-tooltip :enabled="true"
                            :format="{ type: 'fixedPoint', precision: 2}"
                            :customize-tooltip="customizeTooltip"
                            location="edge" />
            </dx-chart>
        </rd-card-content>
    </rd-card>
</template>

<script>
    // @ is an alias to /src
    //import Axios from 'axios';
    //import router from 'vue-router';
    //import sideNav from '../components/sideNav/Index'
    import { mapFields } from 'vuex-map-fields';
    import { mapState, mapActions, mapGetters } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'
    import { DxChart, DxTooltip } from 'devextreme-vue/chart';

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboardValuesByDepartmentAndType',
        created() {
            this.setValuesByDepartmentAndType();
        },
        data() {
            return {
                commonSeriesSettings: {
                    type: 'stackedbar',
                    argumentField: 'Department',
                },
                legendSettings: {
                    visible: false,
                    verticalAlignment: 'bottom',
                    horizontalAlignment: 'center',
                    font: {
                        size: 10
                    }
                },
                argumentSettings: {
                    label: {
                        //overlappingBehavior: 'ignore',
                        indentFromAxis: 5,
                        displayMode: 'rotate',
                        rotationAngle: 45,
                        textOverflow: 'ellipsis',
                        font: {
                            size: 10
                        }
                    },
                }
            }
        },
        computed: {
            ...mapState(name, ['instancesByDepartment']),
            ...mapGetters(name, ['getValuesByDepartmentAndTypeChartDataSource', 'getValuesByDepartmentAndTypeChartSeries'])
        },
        methods: {
            ...mapActions(name, ['setValuesByDepartmentAndType']),
            customizeTooltip(pointInfo) {
                return {
                    text: `${pointInfo.seriesName}: ${pointInfo.valueText}`
                };
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        components: {
            DxChart,
            DxTooltip
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
